import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import projects from './projects-list.json';
import './Projects.css';

const Projects = () => {
  const [searchParams] = useSearchParams();
  const typeFilter = searchParams.get('type');

  const filteredProjects = typeFilter 
    ? projects.filter(p => p.category === typeFilter)
    : projects;

  const title = typeFilter === 'extension' ? 'Browser Extensions' 
    : typeFilter === 'mobile' ? 'Mobile Apps' 
    : 'Projects';

  return (
    <>
      <Helmet>
        <title>{title} - Victor Barbarosh</title>
        <meta name="description" content="Software projects and applications" />
      </Helmet>
      
      <div className="platform-page">
        <Link to="/" className="home-link top">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Home" className="home-icon" />
          Home
        </Link>

        <header className="platform-header">
          <h1>{title}</h1>
          <p className="platform-description">
            {typeFilter === 'extension' ? 'Chrome and Edge browser extensions' 
              : typeFilter === 'mobile' ? 'Android and iOS mobile applications'
              : 'Software projects and applications I\'ve built'}
          </p>
          {typeFilter && (
            <Link to="/projects" className="clear-filter">View all projects</Link>
          )}
        </header>

        <div className="posts-grid">
          {filteredProjects.map((project) => (
            <article key={project.id} className="post-card">
              {project.logo && (
                <img src={project.logo} alt={project.title} className="project-logo" />
              )}
              <div className="post-meta">
                <span className={`category-badge ${project.status}`}>{project.status}</span>
                <time>{new Date(project.dateCompleted).toLocaleDateString()}</time>
              </div>
              <h2>{project.title}</h2>
              <p className="post-summary">{project.briefSummary}</p>
              <div className="tech-tags">
                {project.technologies.map(tech => (
                  <span key={tech} className="tech-tag">{tech}</span>
                ))}
              </div>
              <div className="post-actions">
                <Link to={`/projects/${project.id}`} className="read-more-btn">
                  View Project
                </Link>
              </div>
            </article>
          ))}
        </div>

        <Link to="/" className="home-link bottom">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Home" className="home-icon" />
          Home
        </Link>
      </div>
    </>
  );
};

export default Projects;
